import React from 'react';
import { Heart, Camera, PenTool, Target, Settings, Clock } from 'lucide-react';
import { OnboardingStepProps } from '../../../types/onboarding';
import {
  WelcomeContainer,
  WelcomeIcon,
  WelcomeTitle,
  WelcomeDescription,
  WelcomeFeatures,
  WelcomeFeature,
  FeatureIcon,
  FeatureText,
  TimeEstimate
} from '../../../styles/onboarding/Onboarding.styles';
import { Icon } from '../../../components/shared';

export const WelcomeStep: React.FC<OnboardingStepProps> = ({
  onNext
}) => {
  return (
    <WelcomeContainer>
      <WelcomeIcon>
        <Icon icon={Heart} size={64} variant="filled" />
      </WelcomeIcon>
      <WelcomeTitle>Welcome to Plenty of Hearts</WelcomeTitle>
      <WelcomeDescription>
        We're excited to help you find meaningful connections! Let's set up your profile to get you started.
      </WelcomeDescription>
      
      <WelcomeFeatures>
        <WelcomeFeature>
          <FeatureIcon>
            <Icon icon={Camera} size={24} />
          </FeatureIcon>
          <FeatureText>Add photos to showcase your personality</FeatureText>
        </WelcomeFeature>
        <WelcomeFeature>
          <FeatureIcon>
            <Icon icon={PenTool} size={24} />
          </FeatureIcon>
          <FeatureText>Write a bio that tells your story</FeatureText>
        </WelcomeFeature>
        <WelcomeFeature>
          <FeatureIcon>
            <Icon icon={Target} size={24} />
          </FeatureIcon>
          <FeatureText>Select interests to find like-minded people</FeatureText>
        </WelcomeFeature>
        <WelcomeFeature>
          <FeatureIcon>
            <Icon icon={Settings} size={24} />
          </FeatureIcon>
          <FeatureText>Set preferences to customize your experience</FeatureText>
        </WelcomeFeature>
      </WelcomeFeatures>

      <TimeEstimate>
        <Icon icon={Clock} size={16} /> This will take about 5-7 minutes
      </TimeEstimate>
    </WelcomeContainer>
  );
};

